import './index.css'

import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { isSameDay } from 'date-fns'

import { selectors as NoteSelectors } from 'data/notes'
import { selectors as UsersSelectors } from 'data/users'
import { trackClickOnActivityItem } from 'data/analytics/actions'

import AvatarGroup from 'components/Utils/AvatarGroup'
import Timeago from 'components/Utils/Timeago'
import RoutesHelper from 'helpers/RoutesHelper'

import ItemSubtitleComment from './ItemSubtitleComment'
import { isCommentActivity } from '../utils'
import { COMMENTS } from 'data/ui/UrlPanelTypes'

const enhance = connect(
  (state, { noteActivity }) => {
    const note = NoteSelectors.getNote(state, noteActivity.get('noteId'))
    const users = UsersSelectors.getUsers(state, noteActivity.get('userIds'))

    return {
      note,
      noteActivity,
      users,
    }
  },
  { trackClickOnActivityItem }
)

class Item extends React.Component {
  state = {
    hovering: false,
  }
  handleClick = event => {
    const {
      note,
      noteActivity,
      setActiveThreadId,
      trackClickOnActivityItem,
    } = this.props

    trackClickOnActivityItem()

    switch (this.props.noteActivity.get('type')) {
      case 'newThread':
      case 'newComment':
        const noteId = note.get('id')
        const threadId = noteActivity.get('metadata').get('threadId')
        setActiveThreadId({ threadId, noteId })
        break
      default:
    }
  }

  renderIcon() {
    switch (this.props.noteActivity.get('type')) {
      case 'content':
        return '✏️ '
      case 'newThread':
      case 'newComment':
        return '💬 '
      default:
        return ' '
    }
  }

  renderAuthors() {
    const { users } = this.props
    return (
      <span className="font-weight-bold">
        <span className="capitalize">
          {users.size > 0 ? users.first().get('username') : 'someone'}{' '}
        </span>
        {users.size > 1 && (
          <FormattedMessage
            id="activity.othersCount"
            defaultMessage={`{count, plural,
              one { and 1 other}
              other { and # others}
            }`}
            values={{ count: users.size - 1 }}
          />
        )}
      </span>
    )
  }

  renderLabel() {
    switch (this.props.noteActivity.get('type')) {
      case 'content':
        return ' edited it '
      case 'newThread':
        return ' commented '
      case 'newComment':
        return ' replied to a comment '
      default:
        return ' '
    }
  }

  renderSubtitle() {
    const { noteActivity } = this.props
    if (isCommentActivity(noteActivity)) {
      return <ItemSubtitleComment noteActivity={noteActivity} />
    }
    return false
  }

  onHover = () => {
    this.setState({ hovering: true })
  }
  onLeave = () => {
    this.setState({ hovering: false })
  }

  render() {
    const { users, note, noteActivity, style } = this.props

    if (!note) {
      return <div className="" style={style} />
    }

    const threadId = noteActivity.getIn(['thread', 'id'])
    const commentId = noteActivity.getIn(['metadata', 'commentId'])

    const to = RoutesHelper.noteChannelShow({
      noteId: note.get('id'),
      channelId: note.get('channelId'),
      noteTitle: note.get('title'),
      options: threadId ? COMMENTS : null,
      threadId,
      commentId: typeof commentId === 'string' ? commentId : null,
    })

    const isToday = isSameDay(new Date(), noteActivity.get('createdAt'))

    return (
      <Link
        to={to}
        onClick={this.handleClick}
        onMouseEnter={this.onHover}
        onMouseLeave={this.onLeave}
        className={classNames(
          'activity-row-item block background-shade-100 margin-top-smaller position-relative shadow-normal-on-hover'
        )}
        style={{
          left: 0,
          right: 0,
          ...style,
          zIndex: this.state.hovering ? 3 : 1,
        }}
      >
        <div
          className={classNames(
            'activity-row-item-inner',
            'flexbox flexbox-align-center',
            'padding-vertical-medium',
            'transition'
          )}
        >
          <div className="flexbox-grow ellipsis" style={{ minWidth: 0 }}>
            <div className="shade-10 padding-horizontal-medium">
              {this.renderIcon()}
              {this.renderAuthors()}
              {this.renderLabel()}
              {isToday && (
                <span className="shade-30">
                  <Timeago
                    lowercase
                    formatToday={date => ``}
                    date={noteActivity.get('createdAt')}
                  />
                </span>
              )}
            </div>
            <div className="flexbox">{this.renderSubtitle()}</div>
          </div>
          <div className="flexbox-no-shrink padding-horizontal-medium">
            {<AvatarGroup users={users.toArray()} size="small" />}
          </div>
        </div>
      </Link>
    )
  }
}

export default enhance(Item)
